"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireDefault(require("react"));
var _core = require("@material-ui/core");
var _hooks = require("@datepicker-react/hooks");
var _dayjs = _interopRequireDefault(require("dayjs"));
var _index = _interopRequireDefault(require("./index.style"));
var _TextField = _interopRequireDefault(require("../../TextField"));
var _calendar = _interopRequireDefault(require("../../../assets/svg/calendar"));
var _VerticalDivider = _interopRequireDefault(require("../../Icons/VerticalDivider"));
const InputRangeDate = props => {
  const {
    datepickerIcon = /*#__PURE__*/_react.default.createElement(_calendar.default, null),
    dividerInputIcon = /*#__PURE__*/_react.default.createElement(_VerticalDivider.default, null),
    placeholderStartDate = 'Start date',
    placeholderEndDate = 'End date',
    handleDatepicker = () => {},
    labelDatepicker = 'Dates',
    startDate = new Date(),
    endDate = new Date(),
    focusedInput = ''
  } = props;
  const classes = (0, _index.default)();
  let inputContainerClass = classes.datepickerInputContainer;
  if (focusedInput === _hooks.START_DATE) {
    inputContainerClass = classes.datepickerInputContainerStart;
  }
  if (focusedInput === _hooks.END_DATE) {
    inputContainerClass = classes.datepickerInputContainerEnd;
  }
  return /*#__PURE__*/_react.default.createElement(_core.Grid, {
    container: true,
    alignItems: "flex-end",
    "data-testid": "gridWrapperRangeDate",
    className: inputContainerClass,
    onClick: handleDatepicker
  }, /*#__PURE__*/_react.default.createElement(_core.Grid, {
    item: true,
    xs: 6
  }, /*#__PURE__*/_react.default.createElement(_TextField.default, {
    name: "startDate",
    "data-testid": "startDate",
    label: labelDatepicker,
    className: classes.datepickerInput,
    value: startDate && (0, _dayjs.default)(startDate).format('ddd, MMM DD'),
    placeholder: placeholderStartDate,
    InputProps: {
      startAdornment: /*#__PURE__*/_react.default.createElement(_core.InputAdornment, {
        position: "start",
        className: classes.inputAdornment
      }, datepickerIcon),
      readOnly: true
    }
  })), /*#__PURE__*/_react.default.createElement(_core.Grid, {
    item: true,
    xs: 6
  }, /*#__PURE__*/_react.default.createElement(_TextField.default, {
    name: "endDate",
    className: classes.datepickerInput,
    placeholder: placeholderEndDate,
    value: endDate && (0, _dayjs.default)(endDate).format('ddd, MMM DD'),
    InputProps: {
      startAdornment: focusedInput ? /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null) : /*#__PURE__*/_react.default.createElement(_core.InputAdornment, {
        position: "start",
        className: classes.inputAdornmentEnd
      }, dividerInputIcon),
      readOnly: true
    }
  })));
};
var _default = exports.default = InputRangeDate;